
import {defineComponent, ref, watch} from "vue";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.js";
import {Actions} from "@/store/enums/StoreEnums";
import {useStore} from "vuex";
import {IStock} from "@/views/apps/stocks/StocksListing.vue";

export default defineComponent({
  name: "assign-product-modal",
  props: ['stocks', 'product', "reloadData"],
  components: {},
  setup(props) {
    const store = useStore();
    const formRef = ref<null | HTMLFormElement>(null);
    const assignProductModalRef = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);
    const stocksList = ref<Array<IStock>>(props.stocks);
    const formData = ref({
      productID: props.product && props.product.ID,
      stockID: null,
      quantity: 0
    });

    watch(() => props.product, first => {
     formData.value.productID = first.ID
    });

    const rules = ref({
      stockID: [
        {
          required: true,
          message: "Stock is required",
          trigger: "change",
        },
      ],
      quantity: [
        {
          required: true,
          min: 0,
          message: "Quantity is required",
          trigger: "change",
        },
      ]
    });

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;

          setTimeout(() => {
            loading.value = false;

            store
                .dispatch(Actions.ADD_TRANSACTION, formData.value)
                .then(() => {
                  loading.value = false;
                  props.reloadData

                  Swal.fire({
                    text: "All is cool! Now you submit this form",
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Ok!",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    }
                  })/*.then(function () {
                    hideModal(assignProductModalRef.value);
                  });*/
                })
                .catch(() => {
                  loading.value = false;

                  Swal.fire({
                    text: store.getters.getErrors[0],
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Try again!",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-danger",
                    },
                  });
                });
          }, 2000);
        } else {
          Swal.fire({
            text: "Sorry, looks like there are some errors detected, please try again.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return false;
        }
      });
    };

    return {
      formData,
      rules,
      submit,
      formRef,
      loading,
      assignProductModalRef,
      stocksList
    };
  },
});
